/**
 * Dev-only logger. In production builds (NODE_ENV=production) all methods no-op,
 * so debug output never reaches end users. Use this instead of raw `console.*`.
 */
const isDev = process.env.NODE_ENV !== "production";

export const log = {
  error: (...args) => { if (isDev) console.error(...args); },
  warn:  (...args) => { if (isDev) console.warn(...args);  },
  info:  (...args) => { if (isDev) console.info(...args);  },
  debug: (...args) => { if (isDev) console.debug(...args); },
};

export default log;
